import {Table} from 'antd'
import {useEffect, useState} from 'react'
import styled from 'styled-components'
import {Tooltip} from 'antd'
import {formatDateTime} from 'helpers/dates'

console.log('RailGatewayStatusTable imported!')

const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    white-space: pre-line;
    text-align: center;
  }
`
const getRowKey = record => {
  return `${record?.gid}-${record?.timestamp}`
}

const getColumns = () => [
  {
    title: 'Timestamp',
    dataIndex: 'timestamp',
    key: 'timestamp',
    align: 'center',
    render: (text, row) => formatDateTime(text)
  },
  {
    title: 'Location (Accuracy)',
    dataIndex: 'location',
    key: 'location',
    align: 'center',
    render: (text, row) => {
      const lat = row.latitude ? parseFloat(row.latitude).toFixed(3) : 'N/A'
      const lon = row.longitude ? parseFloat(row.longitude).toFixed(3) : 'N/A'
      const accuracy = row.position_accuracy || 'N/A'
      return `${lat}, ${lon} (${accuracy})`
    }
  },
  {
    title: 'Speed (Accuracy)',
    dataIndex: 'speed',
    key: 'speed',
    align: 'center',
    render: (text, row) => {
      const speed = row.speed
      const accuracy = row.speed_accuracy || 'N/A'
      return `${speed} (${accuracy})`
    }
  },
  {
    title: 'Heading (Accuracy)',
    dataIndex: 'heading',
    key: 'heading',
    align: 'center',
    render: (text, row) => {
      const heading = row.heading
      const accuracy = row.heading_accuracy || 'N/A'
      return `${heading} (${accuracy})`
    }
  },
  {
    title: 'Voltage',
    dataIndex: 'voltage',
    key: 'voltage',
    align: 'center'
  },
  {
    title: 'Current',
    dataIndex: 'current',
    key: 'current',
    align: 'center'
  },
  {
    title: 'Charge Status',
    dataIndex: 'charge_status',
    key: 'charge_status',
    align: 'center',
    render: text => (
      <Tooltip title={text}>
        <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px'}}>
          {text}
        </div>
      </Tooltip>
    )
  },
  {
    title: 'VBus Status',
    dataIndex: 'vbus_status',
    key: 'vbus_status',
    align: 'center',
    render: text => (
      <Tooltip title={text}>
        <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px'}}>
          {text}
        </div>
      </Tooltip>
    )
  },
  {
    title: 'Error Reason',
    dataIndex: 'error_reason',
    key: 'error_reason',
    align: 'center',
    render: text => (
      <Tooltip title={text}>
        <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px'}}>
          {text}
        </div>
      </Tooltip>
    )
  },
  {
    title: 'Error Sensor',
    dataIndex: 'error_sensor',
    key: 'error_sensor',
    align: 'center',
    render: text => (
      <Tooltip title={text}>
        <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100px'}}>
          {text}
        </div>
      </Tooltip>
    )
  }
]

const RailGatewayStatusTable = ({data, pagination, rowKeyFunc = getRowKey}) => {
  console.log('RailGatewayStatusTable', data, pagination)
  const [columns, setColumns] = useState()

  useEffect(() => {
    setColumns(getColumns())
  }, [])

  if (!data) return <></>
  if (!columns) return <></>
  if (data.length === 0) return <div style={{textAlign: 'center'}}>No data available</div>
  return (
    <StyledTable
      data-testid="rail-gateway-status-table"
      columns={columns}
      dataSource={data}
      loading={!data}
      pagination={pagination}
      rowKey={record => rowKeyFunc(record)}
      rowClassName="antd-table-row"
    />
  )
}

export default RailGatewayStatusTable
